export const GET_ALL_ANNOUNCES = 'GET_ALL_ANNOUNCES';
export const GET_MANAGER_ANNOUNCES = 'GET_MANAGER_ANNOUNCES';
export const GET_UNREAD = 'GET_UNREAD';
